"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dropzone_1 = __importDefault(require("react-dropzone"));
var Button_1 = __importDefault(require("../Button"));
var uploader = function (props) {
    var files = props.files, onDrop = props.onDrop, showFiles = props.showFiles, localization = props.localization, multiple = props.multiple, allowedTypes = props.allowedTypes, maxFiles = props.maxFiles;
    var calculatedMaxFiles = !multiple ? 1 : maxFiles;
    var handleOnDrop = function (acceptedFiles, rejectedFiles) {
        if (!rejectedFiles[0]) {
            onDrop(acceptedFiles);
        }
    };
    var button;
    if (localization.button) {
        button = react_1.default.createElement(Button_1.default, { type: "button" }, localization.button);
    }
    var fileList;
    if (showFiles) {
        fileList = (react_1.default.createElement("div", { className: "file_list" },
            react_1.default.createElement("ul", null, files.map(function (f) { return (react_1.default.createElement("li", { key: f.name },
                f.name,
                " - ",
                f.size,
                " bytes")); }))));
    }
    return (react_1.default.createElement("div", { className: "emankit__uploader" },
        fileList,
        react_1.default.createElement(react_dropzone_1.default, { onDrop: handleOnDrop, multiple: multiple, accept: allowedTypes, maxFiles: calculatedMaxFiles }, function (_a) {
            var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, fileRejections = _a.fileRejections;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", __assign({}, getRootProps(), { className: "dropzone" }),
                    react_1.default.createElement("input", __assign({}, getInputProps())),
                    react_1.default.createElement("p", { className: "text" }, localization.text),
                    react_1.default.createElement("p", null, localization.or),
                    button),
                react_1.default.createElement("ul", { className: "errors_list" }, fileRejections.map(function (_a) {
                    var file = _a.file, errors = _a.errors;
                    return (react_1.default.createElement("li", { key: file.name },
                        file.name,
                        ": ",
                        react_1.default.createElement("span", null, errors.map(function (e) { return e.message; }).join(", "))));
                }))));
        })));
};
uploader.defaultProps = {
    multiple: false,
};
exports.default = uploader;
//# sourceMappingURL=index.js.map